export default {"src":"/_next/static/media/0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82.bb683c2d.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};